import { BadgeCheck, Building2, Zap, Eye } from "lucide-react";
import { HOME } from "@/constants/testIds";

const POINTS = [
  {
    icon: BadgeCheck,
    title: "ISO · HACCP · OHSAS Belgeli",
    desc: "Hijyen ve kalite kontrolünü sürekli ön planda tutuyoruz; kalite standartlarımız ISO, HACCP ve OHSAS belgeleriyle tescilli.",
  },
  {
    icon: Building2,
    title: "Sütunsuz & Kademeli Salonlar",
    desc: "Salonlarımız her açıdan mükemmel görüş sağlayacak şekilde sütunsuz, kademeli ve yüksek tavanlı tasarlandı.",
  },
  {
    icon: Zap,
    title: "Kesintisiz Gösteri Altyapısı",
    desc: "Otomatik açılır sahne sistemi, özel ışıklandırma, kanallı klima ve tüm sistemleri çalıştırabilecek güçte jeneratör.",
  },
  {
    icon: Eye,
    title: "Şeffaf Mutfak & Pastane",
    desc: "Arzu eden misafirlerimiz günün her saatinde mutfak, pastane ve çamaşırhanemizi gezip bizi denetleyebilir.",
  },
];

export const Heritage = () => (
  <section data-testid={HOME.heritageSection} className="py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-end mb-16">
        <div className="lg:col-span-7">
          <p className="text-xs uppercase tracking-[0.35em] text-[#D4AF37]">Kurumsal</p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#F5F5F0] mt-5 gold-rule">
            1973'ten Beri <span className="font-romance text-[#E5C783]">Standardın Üstünde</span>
          </h2>
        </div>
        <p className="lg:col-span-5 text-sm font-light leading-relaxed text-[#B3B0A8]">
          İlk günden bu yana sektördeki standardı yakalamayı değil, her zaman standardın üstünde
          neler yapabileceğimizi araştırdık. Hedefimizde hep misafirlerimize daha çok ne
          sunabileceğimiz oldu.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#D4AF37]/15 border border-[#D4AF37]/15">
        {POINTS.map(({ icon: Icon, title, desc }) => (
          <div key={title} className="bg-[#121110] p-10 hover:bg-[#1A1817] transition-colors duration-500 group">
            <Icon size={26} strokeWidth={1} className="text-[#D4AF37] transition-transform duration-500 group-hover:-translate-y-1" />
            <h3 className="font-display text-2xl text-[#F5F5F0] mt-5">{title}</h3>
            <p className="text-sm font-light leading-relaxed text-[#B3B0A8] mt-3">{desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
